import { ReplacementLoca } from "../../utils/i18n/ReplacementLoca";
import { CoopMessageType } from "../../utils/network/generated/protoTypes";
var coopLevel = function (messageItem) {
    return new Map([[ReplacementLoca.zero_0, messageItem.variable1 || ""]]);
};
var projectUserLevel = function (messageItem, additionalData) {
    return new Map([
        [ReplacementLoca.zero_0, additionalData || ""],
        [ReplacementLoca.one_1, messageItem.variable3],
    ]);
};
var promotion = function (messageItem, promotedUser) {
    return new Map([
        [ReplacementLoca.zero_0, messageItem.variable3],
        [ReplacementLoca.one_1, promotedUser || ""],
    ]);
};
export var defaultMapCoopMessageReplacements = function (messageItem, projectData) {
    return new Map([
        [ReplacementLoca.zero_0, projectData || ""],
        [ReplacementLoca.one_1, messageItem.variable2 || ""],
        [ReplacementLoca.two_2, messageItem.variable3 || ""],
    ]);
};
export var mapCoopMessageNotice = new Map([
    [CoopMessageType.COOP_LEVELED_UP, coopLevel],
    [CoopMessageType.COOP_PROJECT_STARTED, projectUserLevel],
    [CoopMessageType.COOP_PROJECT_STOPPED, projectUserLevel],
    [CoopMessageType.COOP_PLAYER_RANK_CHANGED, promotion],
]);



//////////////////
// WEBPACK FOOTER
// ./src/features/cooperative/mapCoopMessageNotice.ts
// module id = 2618
// module chunks = 3